module.exports = __webpack_public_path__ + "static/img/COC2023-25.f323749.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/meeting2023/COC2023-25.png
// module id = 39BU
// module chunks = 0